import { jsx as _jsx, jsxs as _jsxs } from 'react/jsx-runtime.js';
import { Flex, FlexItem } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { RememberMeCheckbox } from '../RememberMeCheckbox/index.js';
import { LoginButton } from '../LoginButton/index.js';
import { ForgotPasswordLink } from '../ForgotPasswordLink/index.js';
import { LoginEmailInput, LoginPasswordInput } from '../Inputs/index.js';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks.js';
import { credentialsSelector, isLoadingSelector, loginRequestThunk, updateEmailError, updateEmailErrorMessage, updatePasswordError, updatePasswordErrorMessage, } from '../../../views/Login/loginSlice.js';
import { validatePassword } from '../../../helpers/validatePassword.js';
import { validateEmail } from '../../../helpers/validateEmail.js';
import { isInTwoStepWrapper } from '../../../tracking/constants.js';
import { useTrack } from '../../../tracking/common/hooks/useTrack.js';
import { activeWrapperSelector } from '../../../redux/core/wrapperContext/wrapperContextSlice.js';
import { AutoCompleteFormWrapper } from '../../common/AutoCompleteFormWrapper/AutoCompleteFormWrapper.js';
import { PasswordlessButton } from '../PasswordlessButton/index.js';
export const LoginWithEmailForm = ({ buttonText, showPasswordless = false, }) => {
    const dispatch = useAppDispatch();
    const isLoading = useAppSelector(isLoadingSelector);
    const { email, password } = useAppSelector(credentialsSelector);
    const activeWrapper = useAppSelector(activeWrapperSelector);
    const { trackBtnClick, trackFieldError } = useTrack(isInTwoStepWrapper(activeWrapper) ? 'twoStep' : 'standard');
    const { t } = useTranslation();
    const loginButtonOnClick = async () => {
        trackBtnClick({
            uniqueName: 'loginWithEmailPassword',
        });
        const validEmail = validateEmail(email.value);
        const validPassword = validatePassword(password.value);
        if (!validEmail) {
            if (validPassword) {
                trackFieldError({ formFieldErrors: 'emailAddressNotValid' });
            }
            else {
                trackFieldError({ formFieldErrors: 'bothFieldsNotValid' });
            }
            dispatch(updateEmailError(!validEmail));
            dispatch(updateEmailErrorMessage(t('loginregistration.email.validation.error')));
        }
        if (!validPassword) {
            if (validEmail) {
                trackFieldError({ formFieldErrors: 'passwordNotValid' });
            }
            dispatch(updatePasswordError(!validPassword));
            dispatch(updatePasswordErrorMessage(t('loginregistration.password.validation.error')));
        }
        if (validEmail && validPassword) {
            dispatch(loginRequestThunk());
        }
        return;
    };
    const ddActionName = isInTwoStepWrapper(activeWrapper)
        ? `rla_forms_twoStep_loginWithEmailPasswordClick`
        : `rla_forms_standard_loginWithEmailPasswordClick`;
    return (_jsx(AutoCompleteFormWrapper, { children: _jsxs(Flex, { flxDirection: "column", gap: "spaceM", children: [_jsx(LoginEmailInput, {}), _jsxs(Flex, { flxDirection: "column", gap: "spaceS", children: [_jsx(LoginPasswordInput, {}), _jsxs(Flex, { flxItems: 'center', flxJustify: 'space-between', children: [_jsx(FlexItem, { py: "spaceS", children: _jsx(RememberMeCheckbox, {}) }), _jsx(ForgotPasswordLink, {})] })] }), _jsx(LoginButton, { isLoading: isLoading, onClick: loginButtonOnClick, ddActionName: ddActionName, buttonText: buttonText }), showPasswordless && (_jsx(PasswordlessButton, { dividerText: t('loginregistration.fullscreenModalContent.returning.divider'), buttonText: t('loginregistration.fullscreenModalContent.returning.loginLink') }))] }) }));
};
//# sourceMappingURL=LoginWithEmailForm.js.map